import { isEmpty, orderBy } from "lodash/fp";

import useMeetingReport from "@app/analytics/MeetingReport/hooks/useMeetingReport";

import ParticipantsListButtonAndPopover from "./ParticipantsListButtonAndPopover";
import ParticipantsListDialog from "./ParticipantsListDialog";

const ParticipantsList = ({
  disabled = false,
  variant,
}: {
  disabled?: boolean;
  variant: "dialog" | "menu";
}) => {
  const { meetingReport } = useMeetingReport();
  const numParticipants = meetingReport?.participants?.length ?? 0;
  const talkTimeData = meetingReport?.talkTimeData ?? [];

  if (!numParticipants || isEmpty(talkTimeData)) return null;

  const sortedData = orderBy("talkTimePercent", "desc", talkTimeData);

  if (variant === "menu") {
    return (
      <ParticipantsListButtonAndPopover
        disabled={disabled}
        numParticipants={numParticipants}
        data={sortedData}
      />
    );
  }

  return (
    <ParticipantsListDialog
      numParticipants={numParticipants}
      data={sortedData}
    />
  );
};

export default ParticipantsList;
